import { RootState } from '../../rootReducer';
import { selectorsFactory } from '../utils';

export const surveyByEmailSlice = (state: RootState) => state.entities.surveys.surveyByEmail;

export const surveysSlice = (state: RootState) => state.entities.surveys.surveys;

export const surveyByEmailById = selectorsFactory.createEntityByIdSelector(surveyByEmailSlice);

export const surveyByEmailUpdatingStateById = selectorsFactory.createUpdatingStateByIdSelector(surveyByEmailSlice);

export const surveysState = selectorsFactory.createStaticKeyWindowStateMemoizedSelector(surveysSlice);
